// Generated by purs version 0.15.0
var otherwise = true;
export {
    otherwise
};
//# sourceMappingURL=index.js.map
